import * as React from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import DocPage from "../../pages/docs-home-page";
import FeedbackPage from "../../pages/feedback-page";
import FuncDocPage from "../../pages/func-doc-page";
import HomePage from "../../pages/home-page";
import Header from "../Header";
import Footer from "../Footer";

import { PATHS } from "./paths";

export default function Routes() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route exact path={PATHS.HOME_PAGE} component={HomePage} />
        <Route exact path={PATHS.DOCS_PAGE} component={DocPage} />
        <Route exact path={`${PATHS.DOCS_PAGE}/:funcName`} component={FuncDocPage} />
        <Route exact path={PATHS.FEEDBACK_PAGE} component={FeedbackPage} />
      </Switch>
      <Footer />
    </Router>
  );
}
